import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { Card, Col, Row } from 'react-bootstrap';
import { Modal } from 'bootstrap';
import Swal from 'sweetalert2';
import CircleLoader from "react-spinners/CircleLoader";
import BeatLoader from 'react-spinners/BeatLoader';


import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTablePagination from 'components/common/advance-table/AdvanceTablePagination';
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';

import { createQuestionsEmet, fetchQuestionsAnswers, deleteEmetQuestionById } from 'api/certifications/emet/questions';

import { handleApiError, successNotification } from 'utils';

import Header from './header/Header';
import EMETColumns from './columns/EMETColumns';
import EMETModal from '../modals/EMETModal';


const override = {
    display: "block",
    margin: "0 auto",
    borderColor: "red"
};

const CandidatesTable = () => {
    const token = useSelector(state => state.authentication.user?.token);
    
	// eslint-disable-next-line
	const [show, setShow] = useState(false);
  	const handleShow = () => setShow(true);

    const [questions, setQuestions] = useState([]); 
	const [rows, setRows] = useState([]); 

	const [isModalOpen, setIsModalOpen] = useState(false);
    const [activeModal, setActiveModal] = useState("");

	const [action, setAction] = useState("");
    const [questionId, setQuestionId] = useState(0);

	const [loading, setLoading] = useState(false);
	const [uploadQuestion, setUploadQuestions] = useState(false);

    useEffect(() => {
		if(token !== null && token !== undefined)
            loadQuestionsAnswersEMET();
		// eslint-disable-next-line
    }, [token]);

    useEffect(() => {
		if (questions.length > 0) {
            const formattedQuestions = questions.map(question => {
                const correctAnswer = question.answers.find(answer => answer.is_correct === 1);
            
                return {
                    index: question.question_number,
                    id: question.question_id,
                    section: question.section_name,
                    instruction: question.question_instruction,
                    question: question.question,
                    answer: correctAnswer ? correctAnswer.option : 'No correct answer',
                    points: question.question_points
                };
            });
			setRows(formattedQuestions);
		}
		// eslint-disable-next-line
	}, [questions]);

	useEffect(() => {
		if(isModalOpen && activeModal === 'EMET') {
			let myModal = new Modal(document.getElementById('emetModal'));
			myModal.show();
		}
	}, [isModalOpen, activeModal]);

    const loadQuestionsAnswersEMET = async () => {
        try {
			setLoading(true);
            const response = await fetchQuestionsAnswers(token);
			setQuestions(response.data.message);
        } catch (error) {
			setQuestions([]);
			handleApiError(error);
        } finally {
			setLoading(false);
		}
    };

	const handleDeleteQuestion = async (question_id) => {
		try {
            const response = await deleteEmetQuestionById(question_id, token);
			console.log(response)
			if(response.data.status === 200) {
                successNotification("Preguntas eliminada correctamente.");
				loadQuestionsAnswersEMET();
            }
		} catch (error) {
			handleApiError(error);
		}
	};

	const handleEdit = (question_id) => {
		setIsModalOpen(true);
        setActiveModal("EMET");
		setAction("Editar");
		setQuestionId(question_id);;
	};

	const handleDelete = (question_id, name) => {
		Swal.fire({
			title: `¿Deseas eliminar esta pregunta?`,
			text: "Una vez eliminado ya no estara disponible esta pregunta.",
			icon: "question",
			confirmButtonText: 'Continuar',
			cancelButtonText: 'Cancelar',
			showCancelButton: true,
			showCloseButton: true,
			allowOutsideClick: false,
			allowEscapeKey: false,
			allowEnterKey: false,
			reverseButtons : true
		}).then((result) => {
			if (result.isConfirmed) 
				confirmDeleteQuestion(question_id);
		}).catch(() => {
			return false;
		})
	};

	const confirmDeleteQuestion = (question_id) => {
		Swal.fire({
			title: "¿Estas seguro?",
			text: "Esta operacion no se puede deshacer.",
			icon: "warning",
			confirmButtonText: 'Eliminar',
			cancelButtonText: 'Cancelar',
			showCancelButton: true,
			showCloseButton: true,
			allowOutsideClick: false,
			allowEscapeKey: false,
			allowEnterKey: false,
			reverseButtons : true
		}).then((result) => {
			if (result.isConfirmed) {	
				handleDeleteQuestion(question_id);
			}
		}).catch(() => {
			return false;
		})
	}

	const handleOpenModal = () => {
		setIsModalOpen(true);
        setActiveModal("EMET");
        setAction("Nueva");
        setQuestionId(0);
	}

	const handleCloseModal = () => {
        setIsModalOpen(false);
        setActiveModal("");
		document.body.style.overflow = 'auto';
        setQuestionId(0);
        loadQuestionsAnswersEMET();
	};

	const handleSubmitQuestions = async (data) => {
        setUploadQuestions(true);
        try {
            const response = await createQuestionsEmet(data, token);
            if(response.data.status === 201) {
                loadQuestionsAnswersEMET();
				successNotification("Preguntas cargados correctamente.");
            }
        } catch(error) {
            handleApiError(error);
        } finally {
			setUploadQuestions(false);
		}
	}

    return (
		<Row className="gx-3">
			{uploadQuestion ? (
				<div className="sweet-loading" style={{
					position: 'fixed',
					top: 0,
					left: 0,
					width: '100vw',
					height: '100vh',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					backgroundColor: 'rgba(255, 255, 255, 0.8)', // Puedes agregar un fondo semitransparente si lo deseas
					zIndex: 9999}} >
					<CircleLoader
						color={"#0a83e6"}
						loading={uploadQuestion}
						cssOverride={override}
						size={150}
						aria-label="Loading..."
						data-testid="loader"
					/>
				</div>
			) : (
				<>
					<Col xxl={12} xl={12}>
						<AdvanceTableWrapper
							columns={EMETColumns(handleEdit, handleDelete)}
							data={rows}
							selectionColumnWidth={52}
							sortable
							pagination
							perPage={10}
							rowCount={rows.length}
						>
							<Card>
								<Card.Header className="px-0">
									<Header table handleShow={handleShow} handleOpen={handleOpenModal} handleLoad={handleSubmitQuestions} />
								</Card.Header>
								<Card.Body className="p-0">
									{ loading ? (
										<div className="sweet-loading" style={{
											position: 'fixed',
											top: 0,
											left: 0,
											width: '100vw',
											height: '100vh',
											display: 'flex',
											justifyContent: 'center',
											alignItems: 'center',
											backgroundColor: 'rgba(255, 255, 255, 0.8)', // Puedes agregar un fondo semitransparente si lo deseas
											zIndex: 9999}} >
											<BeatLoader
												color={"#0a83e6"}
												loading={loading}
												cssOverride={override}
												size={15}
												margin={5}
												aria-label="Loading..."
												data-testid="loader"
											/>
										</div>
									) : (
										<AdvanceTable
											table
											headerClassName="bg-light text-800 align-middle"
											rowClassName="btn-reveal-trigger align-middle"
											tableProps={{
												size: 'sm',
												className: 'fs--1 mb-0 overflow-hidden'
											}}
										/>
									)}
								</Card.Body>
								<Card.Footer>
									<AdvanceTablePagination table />
								</Card.Footer>
							</Card>
						</AdvanceTableWrapper>
					</Col>
					{isModalOpen && activeModal === "EMET" && (
						<EMETModal
							question_id={questionId}
							action={action}
							handleClose={handleCloseModal}
						/>
					)}
				</>
			)}
		</Row>
	);
};

export default CandidatesTable;